import { render, staticRenderFns } from "./index-user-permission-report.vue?vue&type=template&id=2e7dbadc"
import script from "./index-user-permission-report.vue?vue&type=script&lang=js"
export * from "./index-user-permission-report.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports